import { IProductDto } from 'api/products/dto';
import { OrderItems } from './transformBasicPackage';
import { ProductStructure } from 'constants/enums/products';

export type TransformProducts = {
  item: Record<string, IProductDto[]>;
  productStructure: ProductStructure.BundleProduct | ProductStructure.SingleProduct;
};

export const transformProducts = (params: TransformProducts): OrderItems[] => {
  const { item, productStructure } = params;

  if (productStructure === ProductStructure.BundleProduct) {
    return (
      Object.values(item)
        .flat()
        .map(product => ({
          quantity: product.quantity ?? 0,
          name: product?.name ?? '',
          price: product.discountedPrice ?? 0,
        })) ?? []
    );
  } else {
    return (
      Object.values(item)
        .flat()
        .map(product => ({
          quantity: product.quantity ?? 0,
          name: product?.name ?? '',
          price: (product.discountedPrice ?? 0) * (product.quantity ?? 0),
        })) ?? []
    );
  }
};
